<script>
import table from './offers.table'
import getExportedFilename from '@lib/utils/get-exported-filename'

export default {
  name: 'Offers',
  page: {
    title: 'Offers',
  },
  data() {
    return {
      table: null,
    }
  },
  computed: {
    customComparisons() {
      return {
        string: {
          eq: 'contains',
        },
      }
    },
  },
  async created() {
    this.table = table(this)
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'offer-details',
        params: { id: row.id },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Offers">
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :initial-filters="$route.params.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
      :custom-comparisons="customComparisons"
      :multisort="false"
      hider-header-visible
      @row-click="onRowClick"
    />
  </main-layout>
</template>
